module.exports = __webpack_public_path__ + "static/media/image4.fd4dbd4a.png";